/*
 * @Author: Yu JiaZe
 * @Description:
 * @Date: 2020-03-16 10:45:25
 * @LastEditTime: 2021-07-28 17:28:12
 */

import { SandBox, SandboxRecordStatus } from "./sandbox";
import { createEventListenerSandbox } from "./hijack/listener";
import { SideEffectsRecover } from "./hijack";
import { createTimerSandbox } from "./hijack/timer";
import { LifecyclesHookIF } from "../interfaces";

export function createSandboxLifecycles(
    params?: Partial<LifecyclesHookIF> & {
        removeCss?: boolean;
        // 禁用js沙箱
        disableJsSandbox?: boolean;
        // 禁用css沙箱
        disableCssSandbox?: boolean;
    }
): LifecyclesHookIF {
    const sandbox: SandBox = new SandBox();

    // 样式处理: 保存基准样式
    sandbox.saveBaseStyle();
    // 全局变量处理：保存各 app bootstrap 之前的全局变量
    sandbox.snapshotBeforeBoot();

    // 需要清除的列表
    let freeList: (() => SideEffectsRecover)[] = [];

    // 需要恢复的列表
    let recoverList: SideEffectsRecover[] = [];

    // 将劫持事件监听函数，添加freeList
    freeList.push(createEventListenerSandbox(sandbox).free);
    // 将劫持定时器函数，添加freeList
    freeList.push(createTimerSandbox(sandbox).free);

    let bootstraped = false;

    return {
        async beforeBootstrap() {
            params?.beforeBootstrap && params?.beforeBootstrap();
        },

        async afterBootstrap() {
            bootstraped = true;
        },

        async beforeMount() {
            /**
             * bootstrap 模拟区域开始
             */
            if (bootstraped) {
                sandbox.recordStatus = SandboxRecordStatus.BOOTSTRAP;
                if (!params?.disableJsSandbox) {
                    freeList.push(createEventListenerSandbox(sandbox).free);
                    freeList.push(createTimerSandbox(sandbox).free);
                }
            }
            /**
             * bootstrap 模拟区域结束
             */
            // 样式处理：恢复之前卸载的样式
            if (!params?.disableCssSandbox) {
                sandbox.recoverStyle();
            }
            if (!params?.disableJsSandbox) {
                recoverList.forEach((r) => r());
                recoverList = [];
                // 全局变量处理：恢复到 bootstrap 后的状态
                sandbox.recoverWindowToBeforeMount();
                // 全局变量处理：保存 bootstrap 后的状态
                sandbox.snapshotBeforeMount();
            }
            sandbox.recordStatus = SandboxRecordStatus.MOUNT;
            window.__IN_DOLLY__ = true;
        },

        async afterMount() {
        },

        async beforeUnmount() {
            sandbox.recordStatus = SandboxRecordStatus.UNMOUNT;
        },

        async afterUnmount() {
            const removeCss = !params || params.removeCss === undefined ? true : params.removeCss;
            if (!params?.disableCssSandbox) {
                // 样式处理：移除并保存样式
                sandbox.saveCurrentStyle(removeCss);
            }
            if (!params?.disableJsSandbox) {
                // 全局变量处理：恢复到 bootstrap 之前的状态
                sandbox.recoverWindowToBeforeBootstrap();
                freeList.forEach((free) => {
                    recoverList.push(free());
                });
                freeList = [];
            }
            window.__IN_DOLLY__ = false;
        },
    };
}

export function mutateLifecycles(
    passedLifecyles: any,
    sbLifecycles: ReturnType<typeof createSandboxLifecycles>
) {
    const lifecyles =  {...(passedLifecyles || {
        bootstrap: [],
        mount: [],
        unmount: []
    })};

    if (lifecyles.bootstrap || (lifecyles.bootstrap = [])) {
        if (!Array.isArray(lifecyles.bootstrap)) {
            lifecyles.bootstrap = [lifecyles.bootstrap];
        }
        lifecyles.bootstrap.unshift(sbLifecycles.beforeBootstrap);
        lifecyles.bootstrap.push(sbLifecycles.afterBootstrap);
    }

    if (lifecyles.mount || (lifecyles.mount = [])) {
        if (!Array.isArray(lifecyles.mount)) {
            lifecyles.mount = [lifecyles.mount];
        }
        lifecyles.mount.unshift(sbLifecycles.beforeMount);
        lifecyles.mount.push(sbLifecycles.afterMount);
    }

    if (lifecyles.unmount || (lifecyles.unmount = [])) {
        if (!Array.isArray(lifecyles.unmount)) {
            lifecyles.unmount = [lifecyles.unmount];
        }
        lifecyles.unmount.unshift(sbLifecycles.beforeUnmount);
        lifecyles.unmount.push(sbLifecycles.afterUnmount);
    }

    return lifecyles;
}
